<template>
  <header class="admin-header">
    <div
      class="container d-flex justify-content-between align-items-center py-0"
    >
      <div>
        <router-link
          to="/proyectos"
          class="d-flex align-items-center text-decoration-none"
        >
          <img
            src="@/core/assets/images/layout/logo-admin.png"
            alt="Logo panel de administración"
            class="logo"
          />
          <!-- TODO replace app icon -->
          <h2 class="title text-white font-weight-bold text-uppercase my-0">
            Mirana
          </h2>
        </router-link>
      </div>

      <div class="d-flex align-items-center">
        <UserDropdown :user="user" @logout="logout()" />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

import { LocalStorage, UserDropdown } from "wize-admin";
import { SecurityService } from "@/core/services";

export default {
  name: "AdminHeader",
  components: {
    UserDropdown,
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
    }),
  },
  methods: {
    async logout() {
      try {
        await this.$store.dispatch("app/loading", true);
        await SecurityService.logout({refreshToken: LocalStorage.getRefreshToken()})
      } catch (error) {
        console.error(error)
      } finally {
        await this.$store.dispatch("app/loading", false);
        this.$store.dispatch("auth/logout").then(() => this.$router.push({name: "login"}));
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "../Styles/header";
</style>
